import { Formik } from "formik";
import { t } from "i18next";
import { object, string } from "yup";

import { VerificationType } from "../../components/VerificationType";
import { VerificationTemplatePageLayout } from "../VerificationTemplatePageLayout";
import { useVerificationTemplatesContext } from "../VerificationTemplatesContext";
import { CustomInstructionsFormSection } from "../../../templates/CustomInstructionsFormSection";
import { EMPLOYMENT_DEFAULT_INSTRUCTIONS } from "../../../templates/customInstructionsConstants";
import { customInstructionsSchemaField } from "../../../templates/customInstructionsValidation";

export function VerificationTemplateType() {
  const { verificationTemplate, setVerificationTemplate, goToNextStep } =
    useVerificationTemplatesContext();

  const schema = object().shape({
    name: string().required().label(t("Template name")),
    check_arguments: object().shape({
      validation_type: string().required().label(t("Validation type")),
      custom_instructions: customInstructionsSchemaField(),
    }),
  });

  return (
    <Formik
      initialValues={verificationTemplate}
      validationSchema={schema}
      onSubmit={(values) => {
        setVerificationTemplate(values);
        goToNextStep();
      }}
    >
      {({ values, handleSubmit, isSubmitting, setValues }) => {
        return (
          <VerificationTemplatePageLayout
            onComplete={handleSubmit}
            submitting={isSubmitting}
          >
            <VerificationType
              digital_verification={
                values.check_arguments.digital_verification ?? false
              }
              handleDigitalVerificationToggle={(v) => {
                setValues((prev) => ({
                  ...prev,
                  check_arguments: {
                    ...prev.check_arguments,
                    digital_verification: v,
                  },
                }));
              }}
            />
            <CustomInstructionsFormSection
              fieldName="check_arguments.custom_instructions"
              defaultInstructionsPlaceholder={EMPLOYMENT_DEFAULT_INSTRUCTIONS()}
            />
          </VerificationTemplatePageLayout>
        );
      }}
    </Formik>
  );
}
